import "./ScreenLayoutIcon.css";

import React, { useEffect, useState } from "react";

import StorageUtil from "../../utils/storage";
import { klassi } from "../../utils/utils";
import { lessonActions } from "../../store/slices/lessonSlice";
import { useAppDispatch } from "../../store";

export interface Layout {
  list: boolean;
  support: boolean;
}
interface Props {
  layout: Layout;
  hasSupport: boolean;
}

export default function ScreenLayoutIcon(props: Props) {
  const { layout, hasSupport } = props;
  const { list, support } = layout;

  const [embedHover, setEmbedHover] = useState(false);
  const [listHover, setListHover] = useState(false);
  const [supportHover, setSupportHover] = useState(false);

  const embedClass = klassi(
    { hover: embedHover, noSupport: !hasSupport },
    "layout-icon-embed"
  );
  const listClass = klassi(
    { active: list, hover: listHover, noSupport: !hasSupport },
    "layout-icon-list"
  );
  const supportClass = klassi(
    { active: support, hover: supportHover },
    "layout-icon-support"
  );
  const dispatch = useAppDispatch();

  useEffect(() => {}, []);

  useEffect(() => {
    const layout = StorageUtil.get<Layout>("layout") || {
      list: true,
      support: true,
    };
    dispatch(lessonActions.setLayout(layout));
  }, [dispatch]);

  const onClick = (target: "list" | "support") => {
    const layout = { list, support };
    layout[target] = !layout[target];
    StorageUtil.set("layout", layout);
    dispatch(lessonActions.setLayout(layout));
  };

  const onEmbedClick = () => {
    const layout = { list, support };
    const some = list && support;
    layout.list = !some;
    layout.support = !some;
    StorageUtil.set("layout", layout);
    dispatch(lessonActions.setLayout(layout));
  };

  return (
    <div className="layout-icon">
      <div
        className={listClass}
        onClick={() => onClick("list")}
        onMouseEnter={() => setListHover(true)}
        onMouseLeave={() => setListHover(false)}
      />
      <div
        className={embedClass}
        onClick={onEmbedClick}
        onMouseEnter={() => {
          setEmbedHover(true);
          setListHover(true);
          setSupportHover(true);
        }}
        onMouseLeave={() => {
          setEmbedHover(false);
          setListHover(false);
          setSupportHover(false);
        }}
      />
      {hasSupport && (
        <div
          className={supportClass}
          onClick={() => onClick("support")}
          onMouseEnter={() => setSupportHover(true)}
          onMouseLeave={() => setSupportHover(false)}
        />
      )}
    </div>
  );
}
